export default __webpack_public_path__ + "static/media/Transparent_Orange_Glow.76655a7a.png";